import { IconButton } from "@common/Buttons";
import Drawer from "@common/Drawer";
import { NavLink, useLocation } from "react-router-dom";
import { NAVLINKS } from "./navlinks";
import { getLoggedInUser } from "@utils/helpers";
import { ADMIN, USER } from "@utils/roleRights";

export default function MobileDrawer({ isOpen, onClose }) {
  const { pathname } = useLocation();
  const { user } = getLoggedInUser();

  const activeClasses = (isActive, link) => {
    const active = isActive || link.activeOnOtherPaths.includes(pathname);
    const role = user && user?.isAdmin ? ADMIN : USER;
    return link.allowedRoles.includes(role)
      ? `${
          active
            ? " !font-bold !text-secondary-main !bg-primary-tint"
            : "!font-medium border-primary-tint border !bg-transparent !text-primary-tint"
        } text-xs flex !px-2.5 h-12 transition-all rounded-md  duration-300 !tracking-wider`
      : "hidden";
  };

  return (
    <Drawer
      className="!bg-secondary-main [&_.ant-drawer-body]:!p-2"
      placement="left"
      open={isOpen}
      width={"70%"}
      onClose={onClose}
    >
      <div className="flex flex-col gap-4 mt-12">
        {NAVLINKS.map((link) => {
          return (
            <NavLink
              to={link.path}
              key={link.label}
              onClick={onClose}
              className={({ isActive }) => activeClasses(isActive, link)}
            >
              {({ isActive }) => {
                const active =
                  isActive || link.activeOnOtherPaths.includes(pathname);
                return active ? (
                  <IconButton
                    icon={link.icon}
                    label={link.label}
                    className={"flex items-center gap-3 transition-all"}
                  />
                ) : (
                  <IconButton
                    icon={link.activeIcon}
                    label={link.label}
                    className={"flex items-center gap-3 transition-all"}
                  />
                );
              }}
            </NavLink>
          );
        })}
      </div>
    </Drawer>
  );
}
